<style lang="less" rel="stylesheet/stylus" scoped>
	.mask {
		width: 100%;
		height: 100%;
		background: rgba(0, 0, 0, .5);
		position: fixed;
		left: 0;
		top: 0;
		z-index: 999;
		display: flex;
		justify-content: center;
		-webkit-align-items: center;
		align-items: center;
		-webkit-justify-content: center;
		justify-content: center;
		font-size: 16px;
		.show-box {
			width: 436px;
			border-radius: 15px;
			text-align: center;
			background: #FFFFFF;
			// animation: alertAnimate .4s cubic-bezier(0.645, 0.045, 0.150, 1);
			p {
				margin: 0 auto;
				display: flex;
				justify-content: center;
				-webkit-align-items: center;
				align-items: center;
			}
			.twoLine-box {
				padding:50px 45px;
				width:436px;
				box-sizing: border-box;
				
				.network {
					font-size: 28px;
					color: #004466;
					line-height: 36px;
				}
				.error-number {
					font-size: 22px;
					color: #003057;
					line-height: 18px;
					margin-top: 26px;
				}
			}
			.btn-box {
				display: flex;
				flex-direction: row;
				height: 80px;
				border-top: 1px solid #9EBFC8;
				div {
					flex: 1;
					box-sizing: border-box;
					font-size: 24px;
					color: #0073AE;
					line-height: 80px;
					&:hover{
						color: #66B8E2;
					}
				}
				div:nth-child(2) {
					box-sizing: border-box;
					border-left: 1px solid #9EBFC8;
					line-height: 80px;
				}
			}
		}
	}
.zoomIn-enter-active,.zoomIn-enter {
 animation: zoomIn .4s  cubic-bezier(0.645, 0.045, 0.150, 1)
}
.zoomIn-leave-active, .zoomIn-leave-to /* .fade-leave-active below version 2.1.8 */ {
  animation:  zoomIn .4s reverse cubic-bezier(0.645, 0.045, 0.150, 1)
}
</style>
<template>
<transition name="zoomIn">
  <div class="mask" v-show="show">
		<div class="show-box ">
			<!-- 两个行文本样式一样或者不一样的的都可以用这个 -->
			<div class="twoLine-box" v-show="sameOne||sameTwo||errorNum||errorAlert">
				<p class="error-number" v-show="errorAlert">{{errorAlert}}</p>
				<p class="network" :style="{fontSize:size+'px'}" v-show="sameOne">{{sameOne}}</p>
				<p class="network" :style="{fontSize:size+'px'}" v-show="sameTwo">{{sameTwo}}</p>
				<!-- 错误代码提示，和上面的两个p不一样 -->
				<p class="error-number" v-show="errorNum">{{errorNum}}</p>
			</div>

			<!-- 按钮 -->
			<div class="btn-box">
				<div v-show="cancal" class="chongshu cursor" @click='cancelE'>{{cancal}}</div>
				<div v-show="btn" class="chongshu cursor" @click='defaultAlert'>{{btn}}</div>
			</div>
		</div>
	</div>
</transition>
</template>

<script>
	/*
	2、show:父组件传递fasle,true来控制盒子组件的显示隐藏（默认为显示）
	3、按钮功能
	      文字描述  事件对应字段 文案对应字段
	左边   取消（）  cancelEvent    cancle   

	右边    确定       ensure         btn

	4、sameOne：加粗大的字
	   sameTwo：加粗大的字
	   errorNum：为小的不加粗的字
	 */
	export default {
		data() {
			return {

			}
		},
		props: {
			show: {
				type: [Boolean,Number],
				default: false,
			},
			btn: {
				type: String,
				default: '',
			},
			cancal: {
				type: String,
				default: '',
			},
			//粗体大字
			sameOne: {
				type: String,
				default: '',
			},
			//粗体大字
			sameTwo: {
				type: String,
				default: '',
			},
			//错误代码字段
			errorNum: {
				type: [Number,String],
				default: null
			},
			//错误提示
			errorAlert:{
              type: String,
				default: ''
			},
			//字体大小
			size:{
				type:Number
			}
		},
		created() {
			
		},
		methods: {
			//=>取消事件
			cancelE() {
				this.$emit('cancelEvent')
			},
			//确定事件
			defaultAlert() {
				this.$emit('ensure')
			}
		}
	}
</script>


// WEBPACK FOOTER //
// src/components/basic/alert.vue